import { Component, OnInit, OnChanges, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Onix } from '../../../models/Onix';
import { Contributor } from '../../../models/Contributor';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-contributor-selector',
  templateUrl: './contributor-selector.component.html',
  styleUrls: ['./contributor-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContributorSelectorComponent),
      multi: true
    }
  ]
})
export class ContributorSelectorComponent implements OnInit  {
  selectedRole: Onix;
  selectedContributor: Contributor;
  selectedBoh: boolean;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bookService: BookService) { }

  ngOnInit() { }

  onRoleChange(e) {
    this.propagateChange(this.toModel());
  }

  onContributorChange(e) {
    this.propagateChange(this.toModel());
  }

  onBohChange(e) {
    this.propagateChange(this.toModel());
  }

  toModel() {
    // console.log('======= ************ toModel', this.selectedRole)

    return this.selectedRole && this.selectedContributor ? new Contributor({
      ruolo: this.selectedRole,

      codice: this.selectedContributor.codice,
      nomecompleto: this.selectedContributor.nomecompleto,
      cognome: this.selectedContributor.cognome,
      nome: this.selectedContributor.nome,

      boh: this.selectedBoh
    })
    : undefined
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Contributor) {

    if (obj) {
      //  console.log('======= ************ writeValue', obj)

      this.selectedRole = obj.ruolo ;
      // console.log(this.selectedRole.value)

      this.selectedContributor = new Contributor({
        ruolo: obj.ruolo,
        codice: obj.codice,
        nomecompleto: obj.nomecompleto,
        cognome: obj.cognome,
        nome: obj.nome
      })

      this.selectedBoh = obj.boh;
    }
    // console.log('======= ************ selectedRole', this.selectedRole)

    // this.propagateChange(this.toModel());
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/contributor-selector/contributor-selector.component.ts